import { Link } from "react-router-dom";

type SectionHeadingProps = {
  title: string;
  eyebrow?: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
};

export default function SectionHeading({
  title,
  eyebrow,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="mb-1 flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-secondary-600">
            <span className="h-[2px] w-5 rounded-full bg-accent-500" aria-hidden="true" />
            {eyebrow}
          </p>
        ) : null}
        <h2 className="text-xl font-semibold text-foreground-950 md:text-2xl">{title}</h2>
        {description ? (
          <p className="mt-1.5 max-w-2xl text-xs leading-relaxed text-foreground-500 md:text-sm">
            {description}
          </p>
        ) : null}
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="focus-ring group inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300/80 bg-white px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-secondary-300 hover:text-secondary-700"
        >
          {actionLabel}
          <i
            className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </Link>
      ) : null}
    </div>
  );
}